export default {"src":"/_next/static/media/insightful_data_visualization.41ca3a1d.svg","height":31,"width":31,"blurWidth":0,"blurHeight":0};